// extracted by mini-css-extract-plugin
export var actions = "_r2-4";
export var item = "_r2-1";
export var price = "_r2-3";
export var quantity = "_r2-2";
export var table = "_r2-0";